module.exports = __webpack_public_path__ + "img/logo-small.97f84425.png";